<div class="ayarlar-container">

  <!-- KESIT MODU SEKMESİ -->
  <div class="ayarlar-sekme">
    <div class="sekme-baslik" (click)="toggleSekme('kesitModu')">
      <i class="icon" [class.chevron-down]="sekmeler.kesitModu" [class.chevron-right]="!sekmeler.kesitModu"></i>
      <span>Kesit Modu</span>
    </div>

    <div class="sekme-icerik" *ngIf="sekmeler.kesitModu">
      <div class="ayar-satiri">
        <label>Mod</label>
        <div class="birim-secim">
          <select [(ngModel)]="kesitAyarlar.kesitModu" (change)="kesitModuDegisti()" class="birim-select">
            <option value="smooth">Smooth (Yumuşak)</option>
            <option value="flip">Flip (Çevir)</option>
          </select>
        </div>
      </div>

      <div class="ayar-satiri checkbox-satiri">
        <label class="checkbox-label">
          <input
            type="checkbox"
            [(ngModel)]="kesitAyarlar.gosterKesitDuzlemi"
            (change)="gosterKesitDuzlemiDegisti()">
          <span>Kesit Düzlemini Göster</span>
        </label>
      </div>

      <div class="ayar-satiri checkbox-satiri">
        <label class="checkbox-label">
          <input
            type="checkbox"
            [(ngModel)]="kesitAyarlar.gosterKesitDolgu"
            (change)="gosterKesitDolguDegisti()">
          <span>Kesit Dolgusu Göster</span>
        </label>
      </div>

      <div class="ayar-satiri checkbox-satiri">
        <label class="checkbox-label">
          <input
            type="checkbox"
            [(ngModel)]="kesitAyarlar.gosterKesitCizgi"
            (change)="gosterKesitCizgiDegisti()">
          <span>Kesit Çizgisi Göster</span>
        </label>
      </div>
    </div>
  </div>

  <!-- GÖRSEL AYARLAR SEKMESİ -->
  <div class="ayarlar-sekme">
    <div class="sekme-baslik" (click)="toggleSekme('gorselAyarlar')">
      <i class="icon" [class.chevron-down]="sekmeler.gorselAyarlar" [class.chevron-right]="!sekmeler.gorselAyarlar"></i>
      <span>Görsel Ayarlar</span>
    </div>

    <div class="sekme-icerik" *ngIf="sekmeler.gorselAyarlar">
      <!-- Kesit Dolgu Rengi -->
      <div class="ayar-satiri" *ngIf="kesitAyarlar.gosterKesitDolgu">
        <label>Dolgu Rengi</label>
        <div class="renk-grup">
          <input
            type="color"
            [(ngModel)]="dolguRenkHex"
            (change)="dolguRenkDegisti()"
            class="renk-input">
          <span class="renk-degeri">{{ dolguRenkHex }}</span>
        </div>
      </div>

      <div class="ayar-satiri" *ngIf="kesitAyarlar.gosterKesitDolgu">
        <label>Dolgu Opaklığı</label>
        <div class="deger-grup">
          <input
            type="range"
            [(ngModel)]="kesitAyarlar.kesitDolguOpacity"
            (input)="dolguOpacityDegisti()"
            min="0"
            max="1"
            step="0.01"
            class="slider">
          <span class="ayar-degeri">{{ (kesitAyarlar.kesitDolguOpacity * 100) | number:'1.0-0' }}%</span>
        </div>
      </div>

      <!-- Kesit Çizgi Rengi -->
      <div class="ayar-satiri" *ngIf="kesitAyarlar.gosterKesitCizgi">
        <label>Çizgi Rengi</label>
        <div class="renk-grup">
          <input
            type="color"
            [(ngModel)]="cizgiRenkHex"
            (change)="cizgiRenkDegisti()"
            class="renk-input">
          <span class="renk-degeri">{{ cizgiRenkHex }}</span>
        </div>
      </div>

      <div class="ayar-satiri" *ngIf="kesitAyarlar.gosterKesitCizgi">
        <label>Çizgi Kalınlığı</label>
        <div class="deger-grup">
          <input
            type="range"
            [(ngModel)]="kesitAyarlar.kesitCizgiKalinlik"
            (input)="cizgiKalinlikDegisti()"
            min="1"
            max="10"
            step="1"
            class="slider">
          <span class="ayar-degeri">{{ kesitAyarlar.kesitCizgiKalinlik }}</span>
        </div>
      </div>
    </div>
  </div>

  <!-- DÜZLEM AYARLARI SEKMESİ -->
  <div class="ayarlar-sekme">
    <div class="sekme-baslik" (click)="toggleSekme('duzlemAyarlari')">
      <i class="icon" [class.chevron-down]="sekmeler.duzlemAyarlari" [class.chevron-right]="!sekmeler.duzlemAyarlari"></i>
      <span>Düzlem Ayarları</span>
    </div>

    <div class="sekme-icerik" *ngIf="sekmeler.duzlemAyarlari">
      <div class="ayar-satiri" *ngIf="kesitAyarlar.gosterKesitDuzlemi">
        <label>Düzlem Boyutu</label>
        <div class="deger-grup">
          <input
            type="range"
            [(ngModel)]="kesitAyarlar.duzlemBoyutu"
            (input)="duzlemBoyutuDegisti()"
            min="100"
            max="2000"
            step="50"
            class="slider">
          <span class="ayar-degeri">{{ kesitAyarlar.duzlemBoyutu }}</span>
        </div>
      </div>

      <div class="ayar-satiri" *ngIf="kesitAyarlar.gosterKesitDuzlemi">
        <label>Düzlem Opaklığı</label>
        <div class="deger-grup">
          <input
            type="range"
            [(ngModel)]="kesitAyarlar.duzlemOpacity"
            (input)="duzlemOpacityDegisti()"
            min="0"
            max="0.5"
            step="0.01"
            class="slider">
          <span class="ayar-degeri">{{ (kesitAyarlar.duzlemOpacity * 100) | number:'1.0-0' }}%</span>
        </div>
      </div>
    </div>
  </div>

  <!-- BUTONLAR -->
  <div class="ayarlar-butonlari">
    <button class="ui mini button" (click)="kaydetAyarlar()" title="Ayarları kaydet">
      <i class="icon save"></i>Kaydet
    </button>
    <button class="ui mini button" (click)="resetAyarlar()" title="Varsayılana dön">
      <i class="icon refresh"></i>Sıfırla
    </button>
  </div>

</div>
